import { render } from "./CharacterDetails.vue?vue&type=template&id=27c55570&scoped=true"
import script from "./CharacterDetails.vue?vue&type=script&lang=js"
export * from "./CharacterDetails.vue?vue&type=script&lang=js"

import "./CharacterDetails.vue?vue&type=style&index=0&id=27c55570&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27c55570"

export default script